import { getEnvironmentVariable } from "../global/environmentVariables";

const HOME_PAGE = getEnvironmentVariable("HOME_PAGE");
const REDIRECT_DOMAIN = getEnvironmentVariable("REDIRECT_DOMAIN");

export function urlParams() {
  var result = {},
    tmp = [];
  if (window.location.search) {
    var items = window.location.search.substr(1).split("&");
    for (var index = 0; index < items.length; index++) {
      tmp = items[index].split("=");
      result[tmp[0]] = decodeURIComponent(tmp[1]);
    }
  }
  return result;
}

export async function redirectUrlAuth(props) {
  let { cognitoProps, redirect_uri } = props;

  const _redirect_uri = localStorage?.getItem("redirect_uri");

  if (!redirect_uri && _redirect_uri) {
    redirect_uri = _redirect_uri;
  } else if (!redirect_uri && HOME_PAGE) {
    redirect_uri = HOME_PAGE;
  } else if (!redirect_uri && REDIRECT_DOMAIN) {
    redirect_uri = REDIRECT_DOMAIN;
  } else if (!redirect_uri && !HOME_PAGE) {
    throw new Error("Missing redirect_uri");
  }

  let urlString = `${redirect_uri}?code=${
    cognitoProps?.code || cognitoProps?.authorizationCode
  }&authorizationCode=${cognitoProps?.code || cognitoProps?.authorizationCode}`;

  if (cognitoProps?.state) {
    urlString += `&state=${cognitoProps.state}`;
  }

  localStorage.removeItem("redirect_uri");
  localStorage.removeItem("state");

  const url = new URL(urlString);

  window.location.assign(url.toString());
}

export function findGetParameter(parameterName) {
  var result = null,
    tmp = [];
  if (window.location.search) {
    var items = window.location.search.substr(1).split("&");
    for (var index = 0; index < items.length; index++) {
      tmp = items[index].split("=");
      if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
    }
  }
  return result;
}
